module.exports = __webpack_public_path__ + "img/Antrian-Active.c7534668.svg";